<template>
    <div>
        <GridPage
            ref="gridPage"
            :form-default="{
                _: {
                    step_1_open: true,
                    is_enabled_schedule: false,
                    load_last_listing: false,
                },
                values: {
                    ebay: {
                        picture_details: {
                            gallery_type: 'Gallery',
                            picture_url: [],
                        },
                        title: '',
                        sku: '',
                        category_id: '',
                        item_specifics: [],
                        condition_id: '',
                        condition_descriptors: [],
                        condition_description: '',
                        description: '',
                        listing_type: 'Chinese',
                        listing_duration: 'Days_7',
                        start_price: '',
                        buy_it_now_price: '',
                        auto_pay: true,
                        reserve_price: '',
                        quantity: 1,

                        best_offer_details: {
                            best_offer_enabled: false,
                        },
                        listing_details: {
                            minimum_best_offer_price: '',
                            best_offer_auto_accept_price: '',
                        },
                        schedule_time: '',

                        shipping_details: {
                            shipping_type: 'FLAT_RATE',

                            domestic_shipping_type: 'Flat',
                            international_shipping_type: 'Flat',
                            shipping_service_options: [
                                {
                                    ship_to_location: [ 'US', ],
                                    shipping_service: 'EconomyShippingFromOutsideUS',
                                    shipping_service_cost: { value: 1, },
                                    shipping_service_additional_cost: { value: 0, },
                                },
                                {
                                    ship_to_location: [ 'US', ],
                                    shipping_service: 'StandardShippingFromOutsideUS',
                                    shipping_service_cost: { value: 5, },
                                    shipping_service_additional_cost: { value: 5, },
                                },
                                {
                                    ship_to_location: [ 'US', ],
                                    shipping_service: 'ExpeditedShippingFromOutsideUS',
                                    shipping_service_cost: { value: 20, },
                                    shipping_service_additional_cost: { value: 20, },
                                },
                            ],
                            international_shipping_service_option: [
                                {
                                    ship_to_location: [ 'Worldwide', ],
                                    shipping_service: 'OtherInternational',
                                    shipping_service_cost: { value: 1, },
                                    shipping_service_additional_cost: { value: 0, },
                                },
                                {
                                    ship_to_location: [ 'Worldwide', ],
                                    shipping_service: 'StandardInternational',
                                    shipping_service_cost: { value: 5, },
                                    shipping_service_additional_cost: { value: 5, },
                                },
                                {
                                    ship_to_location: [ 'Worldwide', ],
                                    shipping_service: 'ExpeditedInternational',
                                    shipping_service_cost: { value: 20, },
                                    shipping_service_additional_cost: { value: 20, },
                                },
                            ],
                            exclude_ship_to_location: [],
                        },
                        shipping_package_details: {
                            weight_major: '',
                            weight_minor: '',
                            package_depth: '',
                            package_length: '',
                            package_width: '',
                            shipping_irregular: false,
                        },
                        dispatch_time_max: '3',
                        country: 'JP',
                        location: 'Tokyo',
                        return_policy: {
                            returns_accepted_option: '',
                            refund_option: '',
                            returns_within_option: '',
                            shipping_cost_paid_by_option: '',

                            international_returns_accepted_option: '',
                            international_refund_option: '',
                            international_returns_within_option: '',
                            international_shipping_cost_paid_by_option: '',
                        },
                    },
                },
                filters: {
                    country: null,
                },
            }"
            :filters-default="{
                listing_type: '',
                sort: 'StartTimeDescending',
            }"
            :filter-items="[
                {
                    vModel: 'listing_type',
                    title: '状態',
                    options: [
                        { text: '全て', value: '' },
                        { text: 'オークション', value: 'Chinese' },
                        { text: '今すぐ落札', value: 'FixedPriceItem' },
                    ],
                },
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        { text: '▲ 開始日時が古い順', value: 'StartTime', },
                        { text: '▼ 開始日時が新しい順', value: 'StartTimeDescending' },
                    ],
                },
            ]"
            filters-q-placeholder="名前,SKU"
            form-modal-id="listing"
            search-action="listing/index"
            row-class="flex-nowrap mx-0 my--2"
            :hide-table="true"
            item-id="ItemID"
            :open-detail-after-saving="false"
            :search-after-saving="true"
            >
            <template v-slot:form="{ form, init }">
                <UserListing
                    ref="model"
                    :model="form"
                    :init="init"
                    @save="$refs.gridPage.save"
                    @destroy="$refs.gridPage.destroy"

                    :response="$refs.gridPage.grid.response"
                    >
                </UserListing>
            </template>

            <template v-slot:before-table="{ response }">
                <template v-if="response.Ack">
                    <b-tabs content-class="" v-model="tabIndex" justified pills card>
                        <b-tab title-item-class="lh-1" class="p-0 mt-3">
                            <template #title>
                                <small>Active</small>
                                <b-spinner type="grow" small v-if="response.ActiveList.ItemArray.Item.length > 0"></b-spinner>
                            </template>

                            <div class="text-right">
                                <small><a href="https://www.ebay.com/sh/lst/active" target="_blank">eBayで一覧を確認</a></small>
                            </div>

                            <div v-for="(item, index) in response.ActiveList.ItemArray.Item">
                                <MeListingListItem
                                    v-model="response.ActiveList.ItemArray.Item[index]"
                                    @copy="onClickCopy(item.ItemID)"
                                    />
                            </div>

                            <Pagenation
                                v-model="response.ActiveList.PaginationResult.PageNumber"
                                @input="pagenation"
                                />
                        </b-tab>

                        <b-tab title-item-class="lh-1" class="p-0 mt-3">
                            <template #title>
                                <small>Scheduled</small>
                                <b-spinner type="grow" small v-if="response.ScheduledList.ItemArray.Item.length > 0"></b-spinner>
                            </template>

                            <div class="text-right">
                                <small><a href="https://www.ebay.com/sh/lst/scheduled" target="_blank">eBayで一覧を確認</a></small>
                            </div>

                            <div v-for="(item, index) in response.ScheduledList.ItemArray.Item">
                                <MeListingListItem v-model="response.ScheduledList.ItemArray.Item[index]" />
                            </div>

                            <Pagenation
                                v-model="response.ScheduledList.PaginationResult.PageNumber"
                                @input="pagenation"
                                />
                        </b-tab>

<!--
                        <b-tab title-item-class="lh-1" class="p-0 mt-3">
                            <template #title>
                                <small>Sold</small>
                                <b-spinner type="grow" small v-if="response.SoldList.ItemArray.Item.length > 0"></b-spinner>
                            </template>

                            <div class="text-right">
                                <small><a href="https://www.ebay.com/sh/lst/ended?status=SOLD" target="_blank">eBayで一覧を確認</a></small>
                            </div>

                            <div v-for="(item, index) in response.SoldList.ItemArray.Item">
                                <MeListingListItem v-model="response.SoldList.ItemArray.Item[index]" />
                            </div>

                            <Pagenation
                                v-model="response.SoldList.PaginationResult.PageNumber"
                                @input="pagenation"
                                />
                        </b-tab>
-->

                        <b-tab title-item-class="lh-1" class="p-0 mt-3">
                            <template #title>
                                <small>Unsold</small>
                                <b-spinner type="grow" small v-if="response.UnsoldList.ItemArray.Item.length > 0"></b-spinner>
                            </template>

                            <div class="text-right">
                                <small><a href="https://www.ebay.com/sh/lst/ended?status=UNSOLD_NOT_RELISTED" target="_blank">eBayで一覧を確認</a></small>
                            </div>

                            <div v-for="(item, index) in response.UnsoldList.ItemArray.Item">
                                <MeListingListItem
                                    v-model="response.UnsoldList.ItemArray.Item[index]"
                                    @copy="onClickCopy(item.ItemID)"
                                    />
                            </div>

                            <Pagenation
                                v-model="response.UnsoldList.PaginationResult.PageNumber"
                                @input="pagenation"
                                />
                        </b-tab>
<!--
                        <b-tab title-item-class="lh-1" class="p-0 mt-3">
                            <template #title>
                                <small>あとで一括出品</small>
                                <b-spinner type="grow" small v-if="response.BulkList.ItemArray.Item.length > 0"></b-spinner>
                            </template>

                            <div class="text-right">
                                <small><a href="https://www.ebay.com/sh/lst/ended?status=UNSOLD_NOT_RELISTED" target="_blank">eBayで一覧を確認</a></small>
                            </div>

                            <div v-for="(item, index) in response.BulkList.ItemArray.Item">
                                <MeListingListItem v-model="response.BulkList.ItemArray.Item[index]" />
                            </div>

                            <Pagenation
                                v-model="response.BulkList.PaginationResult.PageNumber"
                                @input="pagenation"
                                />
                        </b-tab>
-->
                    </b-tabs>
                </template>
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import UserListing from '@/components/UserListing.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import ItemInfo from '@/components/ItemInfo.vue'
import MeListingListItem from '@/components/MeListingListItem.vue'
import Pagenation from '@/components/Pagenation.vue'

export default {
    components: {
        GridPage,
        UserListing,
        ItemBadges,
        ItemThumb,
        ItemInfo,
        MeListingListItem,
        Pagenation,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ])
    },
    data() {
        return {
            tabIndex: 0,
        }
    },
    async mounted() {
        // params
//        const referer = this.$route.query['referer']
        const templateId = this.$route.query['template-id']
        const token = this.$route.query['token']
        if (templateId && token) {
            let template = await this.$store.dispatch('listing/template', {
                id: templateId,
                token: token,
            }).then((response) => {
                return response
            }).catch((error) => {
                return error
            })
            if (template.status !== 200) {
                return
            }
            if (template.length === 0) {
                return
            }

console.log(template)
            template = template.data

            this.$nextTick(async () => {
                while (!this.$refs.gridPage) {
                    await sleep(1000)
                    console.log('takes time some more')
                }
                this.$refs.gridPage.add(
                    null,
                    async (form) => {
                        // basic
                        const template_keys = Object.keys(template.basic)
                        for (let i = 0; i < template_keys.length; i++) {
                            const template_key = template_keys[i]
                            const template_value = template.basic[template_keys[i]]
                            form.values.ebay[template_key] = template_value
                        }
                        form.values.ebay.description = (form.values.ebay.description || '')

                        // category
                        await this.$refs.model.$refs.itemCategory.search(null, template.basic.category_id)

                        // specifics
                        const specifics_keys = Object.keys(template.specifics)
                        let is_not_set = true
                        do {
                            await this.$utils.sleep(300)
                            this.$refs.model.$refs.itemSpecifics.set(template.specifics)
                            const value_got = this.$refs.model.$refs.itemSpecifics.get()
                            
                            for (let i = 0; i < specifics_keys.length; i++) {
                                if (value_got[specifics_keys[i]] !== undefined) {
                                    is_not_set = false
                                    break
                                }
                            }
                            console.log(value_got)
                        } while (is_not_set)

                        // hide step.1
                        this.$refs.model.model._.step_1_open = false

                        // schedule_time_default
                        this.$refs.model.onClickScheduledOffset(this.$refs.model.$data._.schedule_time_default)

                        // condition_id
                        console.log('condition_id');
                        if (this.$refs.model.ebay.conditions.length) {
                            switch (template.basic.category_id) {
                                case 183454:
                                    // #183454 CCG Individual Cards
                                    form.values.ebay.condition_id = '4000';
                                    break;
                                case 183455:
                                    // #183455 CCG Mixed Card Lots
                                    form.values.ebay.condition_id = '3000';
                                    break;
                                case 183456:
                                    // #183456 CCG Sealed Packs
                                    form.values.ebay.condition_id = '3000';
                                    break;
                                case 261044:
                                    // #261044 CCG Sealed Boxes
                                    form.values.ebay.condition_id = '3000';
                                    break;
                                case 2535:
                                    // #2535 Other CCG Items
                                    form.values.ebay.condition_id = '3000';
                                    break;
                            }
                            this.$refs.model.onInputConditionId();
                        }

                        // show modal

                    }
                )
            })
        }
    },
    methods: {
//        async listItem(item, provider) {
//            let provider_type = null
//            switch (provider) {
//                case 'amazon':
//                    provider_type = 'inventory'
//                    break
//                case 'ebay':
//                    provider_type = 'store'
//                    break
//            }
//
//            await this.$store
//                .dispatch('item/list_item', { uuid: item.uuid, provider: provider, })
//                .then((response) => {
////                    this.fetch()
//                    this.$emit('sync')
//                })
//                .catch((error) => {
//                })
//        },
        pagenation(page) {
console.log('pagenation')
console.log(page)
            if (event instanceof Event) {
                event.preventDefault()
            }
            this.$refs.gridPage.search(event, page)
        },
        async onClickCopy(item_id) {
console.log('onClickCopy')
console.log(item_id)
            let ebay_item = await this.$store.dispatch('listing/get_ebay_item', item_id)
                .then((resposne) => {
                    return resposne.data.data
                })
console.log(ebay_item)
            this.$refs.gridPage.add(
                null,
                async (form) => {
                    // category
                    await this.$refs.model.$refs.itemCategory.search(null, ebay_item.PrimaryCategory.CategoryID)

                    // specifics
                    const specifics = {}
                    ebay_item.ItemSpecifics.NameValueList.forEach((v) => {
                        specifics[v.Name] = v.Value[0]
                    })

                    const specifics_keys = Object.keys(specifics)
                    let is_not_set = true
                    do {
                        await this.$utils.sleep(300)
                        this.$refs.model.$refs.itemSpecifics.set(specifics)
                        const value_got = this.$refs.model.$refs.itemSpecifics.get()
                        
                        for (let i = 0; i < specifics_keys.length; i++) {
                            if (value_got[specifics_keys[i]] !== undefined) {
                                is_not_set = false
                                break
                            }
                        }
                        console.log(value_got)
                    } while (is_not_set)

                    console.log('condition_id');
                    // SKU
                    let SKU_parsed = null
                    if (SKU_parsed = ebay_item.SKU.match(/(.*)-([0-9]+)$/)) {
                        SKU_parsed[2] = this.$_.padStart(Number(SKU_parsed[2]) + 1, SKU_parsed[2].length, '0')

                        form.values.ebay.sku = SKU_parsed[1] + '-' + SKU_parsed[2]
                    }

                    // listing_type
                    // listing_duration

                    // shipping

                    // env

                    /////////////////////////////////
                    // offer
                    // price
                    // condition
                    // description
                    // title
                    // schedule_time

                    this.$refs.model.loadStep3(ebay_item)
return
                });
        },
    },
}
</script>

